import { render } from "./DictTableView.vue?vue&type=template&id=b6f0c37e&scoped=true"
import script from "./DictTableView.vue?vue&type=script&lang=js"
export * from "./DictTableView.vue?vue&type=script&lang=js"

import "./DictTableView.vue?vue&type=style&index=0&id=b6f0c37e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6f0c37e"]])

export default __exports__